import { EmailTemplate } from "@/types";

export const mailTemplateVariables = [
  "email",
  "name",
  "code",
  "recipient_email",
  "offer_number",
  "client_name",
  "signatory_email",
  "signatory_name",
  "signatory_cc",
  "lizfi_number",
  "front_end_url",
  "process_token",
  "document_name",
  "nom_agence",
  "nom_commercial",
  "external_reference",
  "avis_conformite",
  "offer_id",
  "site_commercial",
  "user_nom",
  "vehicule",
  "prix",
  "commentaire",
  "Commentaire_id",
  "decideur_nom",
  "date_send",
  "charge_etude_nom",
  "simulation_id",
  "client_nom",
  "username",
  "password",
];

export const mailTemplateSampleValues: Record<string, string> = {
  email: "nom.prenom@example.com",
  name: "Nom Prenom",
  code: "482913",
  recipient_email: "analyste@capitole-finance.fr",
  offer_number: "O123456",
  client_name: "Mr Client",
  signatory_email: "signataire.prenom@example.com",
  signatory_name: "Signataire Prenom",
  signatory_cc: "nom.prenom@example.com",
  lizfi_number: "L123456",
  front_end_url: "https://origination-cpt-dev.teamwill-digital.com",
  process_token: "a1b2c3d4-esign",
  document_name: "Contrat de financement",
  nom_agence: "Agence Ile-de-France",
  nom_commercial: "Sophie Bernard",
  external_reference: "REF-0000",
  avis_conformite: "Avis favorable",
  offer_id: "142",
  site_commercial: "Paris Centre",
  user_nom: "Lucas Petit",
  vehicule: "Peugeot 3008 GT",
  prix: "32 500 €",
  commentaire: "Dossier complet, pièces validées.",
  Commentaire_id: "CMT-2041",
  decideur_nom: "Charge Etude",
  date_send: "04/09/2026",
  charge_etude_nom: "Charge Etude",
  simulation_id: "SIM-8841",
  client_nom: "Mr Client",
  username: "prenom.nom",
  password: "********",
};

function template(partial: EmailTemplate): EmailTemplate {
  return {
    objectType: "odm.contactmechanism.emailtemplate",
    systemUid: "odm-contactmechanism",
    businessData: null,
    daaq: "/",
    copyRecipient: null,
    hiddenRecipient: null,
    ...partial,
  };
}

export const mockEmailTemplates: EmailTemplate[] = [
  template({
    resourceUid: "CreateUserEmailWithCodeTemplate",
    sender: "gestion-mail@teamwill.fr",
    copyRecipient: "${email}",
    hiddenRecipient: "${email}",
    recipient: "${email}",
    subject: "Confirmation email",
    body: 'Hello ${name},<br/><br/>Your account was created.<br/><br/>Please use this code "${code}" to validate.<br/><br/>Best regards.',
    _when_created: "2020-06-23 02:10:25",
    _when_modify: "2023-03-22 14:53:03",
    _who_created: "user",
    _who_modify: "user",
  }),
  template({
    resourceUid: "Prise_en_charge_par_les_etudes",
    sender: "gestion-mail@teamwill.fr",
    copyRecipient: "${recipient_email}",
    hiddenRecipient: "${recipient_email}",
    recipient: "${recipient_email}",
    subject: "Le dossier ${offer_number} pour le client ${client_name}  vous est transmis pour études.",
    body: "Le dossier ${offer_number} pour le client ${client_name}  vous est transmis pour études.",
    _when_created: "2024-05-10 10:18:42",
    _when_modify: "2024-05-10 10:18:42",
    _who_created: "User Anonymous",
    _who_modify: "User Anonymous",
  }),
  template({
    resourceUid: "SendNoticeTemplate",
    businessData: {},
    sender: "twcapitolfinance@gmail.com",
    recipient: "${signatory_email}",
    subject: "Please sign with Teamwill Digital Esign}",
    body: "Bonjour, ci-joint les documents relatifs à votre offre.",
    _when_created: "2023-02-06 13:16:55",
    _when_modify: "2023-02-06 13:16:55",
    _who_created: "system",
    _who_modify: "system",
  }),
  template({
    resourceUid: "SendProposition",
    sender: "gestion-mail@teamwill.fr",
    recipient: "${signatory_email}",
    subject: "Proposition",
    body: "Dear sir ${signatory_name}, <br/><br/>Follow attached your propositon.",
    _when_created: "2022-04-05 18:48:01",
    _when_modify: "2022-04-05 18:48:01",
    _who_created: "User Anonymous",
    _who_modify: "User Anonymous",
  }),
  template({
    resourceUid: "SendwhitoutNoticeTemplate",
    businessData: {},
    sender: "twcapitolfinance@gmail.com",
    recipient: "${signatory_email}",
    subject:
      "Mise en attente : Le dossier N°  ${lizfi_number} / N° ${offer_number} pour le client ${client_name} nécessite des informations complémentaires.",
    body: "Bonjour, ci-joint les documents relatifs à votre offre.",
    _when_created: "2023-02-06 13:16:55",
    _when_modify: "2023-02-06 13:16:55",
    _who_created: "system",
    _who_modify: "system",
  }),
  template({
    resourceUid: "SignConfirmationEmail",
    sender: "gestion-mail@teamwill.fr",
    recipient: "${signatory_email}",
    hiddenRecipient: "${signatory_cc}",
    subject: "Confirmation email Teamwill Digital Esign: ${document_name}",
    body: "Dear sir ${signatory_name}, Please see the attached document.",
    _when_created: "2021-11-22 10:18:42",
    _when_modify: "2021-11-22 10:18:42",
    _who_created: "user",
    _who_modify: "user",
  }),
  template({
    resourceUid: "SignProcessEmail",
    sender: "gestion-mail@teamwill.fr",
    recipient: "${signatory_email}",
    subject: "Please sign with Teamwill Digital Esign: ${document_name}",
    body: "Dear sir ${signatory_name} click <a href='${front_end_url}/${process_token}/'> View Document </a>",
    _when_created: "2021-11-22 10:18:42",
    _when_modify: "2021-11-22 10:18:42",
    _who_created: "user",
    _who_modify: "user",
  }),
  template({
    resourceUid: "SignRefusalEmail",
    sender: "gestion-mail@teamwill.fr",
    recipient: "${email}",
    hiddenRecipient: "${email}",
    subject: "Refusal Alert Teamwill Digital Esign:",
    body: "Dear sir You have rejected to sign the document.",
    _when_created: "2021-11-22 10:18:42",
    _when_modify: "2021-11-22 10:18:42",
    _who_created: "user",
    _who_modify: "user",
  }),
  template({
    resourceUid: "TahaTemplate",
    sender: "gestion-mail@teamwill.fr",
    recipient: "${recipient_email}",
    subject: "Confimation for Offer N°${offer_number}",
    body: "Dear Sir,<br/> We are happy to inform you that your Offer N°${offer_number} was accepted. Please contact us as soon as possible to finalize formalities",
    _when_created: "2023-01-16 18:38:39",
    _when_modify: "2023-01-16 18:38:39",
    _who_created: "4e535f9e-bb29-496a-a273-e6c77b825ff5@TWDDemo",
    _who_modify: "4e535f9e-bb29-496a-a273-e6c77b825ff5@TWDDemo",
  }),
  template({
    resourceUid: "TahaTemplate2",
    sender: "gestion-mail@teamwill.fr",
    recipient: "${recipient_email}",
    subject: "Confimation for Offer N°${offer_number}",
    body: "Dear Sir,<br/> We are happy to inform you that your Offer N°${offer_number} was accepted. Please contact us as soon as possible to finalize formalities",
    _when_created: "2023-01-17 08:47:38",
    _when_modify: "2023-01-17 08:47:38",
    _who_created: "9b2489e4-7ec7-48ca-bb7f-01ac4b310468@TWDDemo",
    _who_modify: "9b2489e4-7ec7-48ca-bb7f-01ac4b310468@TWDDemo",
  }),
  template({
    resourceUid: "TEMPLATE_Avis_conformite",
    businessData: {},
    sender: "noreply@nr.capitole-finance.fr",
    copyRecipient: "${recipient_email}",
    hiddenRecipient: "etudes@capitole-finance.fr",
    recipient: "${recipient_email}",
    subject:
      "La conformité a donné son avis pour le dossier ${offer_number} / ${external_reference} pour le client ${client_name}.",
    body: 'AGENCE : ${nom_agence}<br/>COMMERCIAL : ${nom_commercial}<br/>Nº DOSSIER : ${offer_number} / ${external_reference}<br/>CLIENT : ${client_name}<br/>CONFORMITE : Avis de la conformité ${avis_conformite}<br/>LIEN : <a href="https://origination-cpt-dev.teamwill-digital.com/mo/demand/detail/${offer_id}">Voir la demande</a>',
    _when_created: "2025-02-25 00:00:00",
    _when_modify: "2025-02-25 00:00:00",
    _who_created: "admin",
    _who_modify: "admin",
  }),
  template({
    resourceUid: "TEMPLATE_Avis_conformite_PPE",
    businessData: {},
    sender: "gestion-mail@teamwill.fr",
    hiddenRecipient: "etudes@capitole-finance.fr",
    recipient: "${recipient_email}",
    subject:
      "La conformité a donné son avis pour le dossier ${offer_number} / ${external_reference} pour le client ${client_name}.",
    body: 'AGENCE : ${nom_agence}<br/>COMMERCIAL : ${nom_commercial}<br/>N&#186; DOSSIER : ${offer_number} / ${external_reference}<br/>CLIENT : ${client_name}<br/><p><b>CONFORMIT&#201; <span style="color:#C62828;">PPE</span> :</b>${avis_conformite}</p>LIEN : <a href="https://origination-cpt-dev.teamwill-digital.com/mo/demand/detail/${offer_id}">Voir la demande</a>',
    _when_created: "2025-02-25 00:00:00",
    _when_modify: "2025-02-25 00:00:00",
    _who_created: "admin",
    _who_modify: "admin",
  }),
  template({
    resourceUid: "TEMPLATE_envoie_SE",
    businessData: {},
    sender: "noreply@nr.capitole-finance.fr",
    copyRecipient: "${recipient_email}",
    hiddenRecipient: "${recipient_email}",
    recipient: "${recipient_email}",
    subject:
      "VOTRE CONTRAT LOA – SIGNATURE ELECTRONIQUE ${offer_number} / ${external_reference} pour le client ${client_name}.",
    body: 'Madame, Monsieur,<br/>Nous avons le plaisir de vous annoncer que votre demande de location est accept&#233;e.<br/>Vous en &#234;tes &#224; l&#8217;&#233;tape de signature du contrat.<br/>Pour proc&#233;der &#224; la signature &#233;lectronique de celui-ci, vous allez recevoir un email de notre partenaire Universign &#171; Signature Service &#187;.<br/>/! Si vous ne recevez pas cet email dans les 6h, pensez &#224; v&#233;rifier vos spams ou courriers ind&#233;sirables.<br/>Pour vous aider dans votre parcours de signature, vous trouverez un support en pi&#232;ce jointe &#224; lire attentivement ainsi qu&#8217;une vid&#233;o <a href="https://www.capitole-finance.com/fr/comment-signer-electroniquement-votre-contrat-en-deux-etapes.html">lien video</a> <br/>Nous attirons particuli&#232;rement votre attention sur le cadrage de votre pi&#232;ce d&#8217;identit&#233; pr&#233;alable &#224; la signature du contrat pour garantir le succ&#232;s de votre signature. <br/>Nous vous remercions de votre confiance, et vous prions d&#8217;accepter, Madame, Monsieur, nos sinc&#232;res salutations. <br/>Bien cordialement <br/>Service Assistante Commerciale P&#244;le Automobile <br/>TEL: 09 77 40 19 99 <br/>MAIL: assistance-commerciale@capitole-finance.fr',
    _when_created: "2025-02-25 00:00:00",
    _when_modify: "2025-02-25 00:00:00",
    _who_created: "admin",
    _who_modify: "admin",
  }),
  template({
    resourceUid: "TEMPLATE_En_attente_Info_Compl_DRI",
    sender: "gestion-mail@teamwill.fr",
    copyRecipient: "${recipient_email}",
    hiddenRecipient: "${recipient_email}",
    recipient: "odm.test.email@teamwill.com",
    subject:
      "Le dossier ${offer_number} pour le client ${client_name}  nécessite des documents supplémentaire pour analyse approfondie 2",
    body: "Le dossier ${offer_number} pour le client ${client_name} nécessite des documents supplémentaire pour analyse approfondie .<br/>Nom de l'apporteur : ${site_commercial}<br/>Nom du commercial : ${user_nom}<br/>N° Dossier : ${offer_number}<br/>Nom du Client : ${client_name}<br/>Bien à Financer : ${vehicule}<br/>Montant TTC à Financer : ${prix}<br/><br/>Cordialement,",
    _when_created: "2024-05-10 10:18:42",
    _when_modify: "2024-05-10 10:18:42",
    _who_created: "User Anonymous",
    _who_modify: "User Anonymous",
  }),
  template({
    resourceUid: "TEMPLATE_Notifs_refus_Etude",
    sender: "noreply@nr.capitole-finance.fr",
    copyRecipient: "${recipient_email}",
    hiddenRecipient: "safe.jilani@teamwillgroup.com",
    recipient: "${recipient_email}",
    subject:
      "Le dossier ${external_reference} /${offer_number}  pour le client ${client_name} a été refusé par ${charge_etude_nom} .",
    body: "AGENCE :${site_commercial}<br/>COMMERCIAL :${nom_commercial}<br/>N° Dossier: ${external_reference}/${offer_number}<br/>CLIENT: ${client_name}<br/>COMMENTAIRE :${commentaire}<br/>Le dossier a été refusé par ${decideur_nom} le ${date_send}",
  }),
  template({
    resourceUid: "TEMPLATE_Notifs_sans_suite_Etude",
    sender: "gestion-mail@teamwill.fr",
    copyRecipient: "${recipient_email}",
    hiddenRecipient: "${recipient_email}",
    recipient: "${recipient_email}",
    subject: "Le dossier ${offer_number} pour le client ${client_name} a été classer sans suite .",
    body: "Le dossier ${offer_number} pour le client ${client_name} a été classer sans suite.<br/>Cordialement,",
    _when_created: "2024-02-02 00:00:00",
    _when_modify: "2024-02-02 00:00:00",
    _who_created: "user",
    _who_modify: "user",
  }),
  template({
    resourceUid: "TEMPLATE_Notif_accord_commercial",
    sender: "noreply@nr.capitole-finance.fr",
    copyRecipient: "${recipient_email}",
    hiddenRecipient: "safe.jilani@teamwillgroup.com",
    recipient: "${recipient_email}",
    subject:
      "Le dossier ${external_reference} /${offer_number}  pour le client ${client_name} a été accepté par ${charge_etude_nom} .",
    body: "AGENCE :${site_commercial}<br/>COMMERCIAL :${nom_commercial}<br/>N° Dossier: ${external_reference}/${offer_number}<br/>CLIENT: ${client_name}<br/>COMMENTAIRE :${commentaire}<br/>Le dossier a été Accepté par ${decideur_nom} le ${date_send}",
  }),
  template({
    resourceUid: "TEMPLATE_Creation_compte_WELEAF",
    sender: "noreply@nr.capitole-finance.fr",
    copyRecipient: null,
    hiddenRecipient: null,
    recipient: "${recipient_email}",
    subject: "Votre compte WELEAF a &#233;t&#233; cr&#233;&#233;",
    body: 'Bonjour,<br><br>Votre compte WELEAF vient d&#39;&#234;tre cr&#233;&#233;, merci de vous connecter avec :<br><br>Nom d&#39;utilisateur : <b>${username}</b><br>Mot de passe (&#224; modifier &#224; la premi&#232;re connexion) : <b>${password}</b><br>Lien WELEAF : <a href="https://origination-cpt-dev.teamwill-digital.com/">https://origination-cpt-dev.teamwill-digital.com/</a><br><br>Cordialement,',
  }),
];
